module.exports = __webpack_public_path__ + "image-a2dbc49a8e8b.png";